<template>
    <v-card>
        <v-card-title>
            Condición General
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialogForm = true">Nuevo</v-btn>
            <condicionGeneralModal :cargar="dialogForm" :seleccionado="seleccionado"
                :tituloFormulario="tituloFormulario" :lista="lista" :listaEstado="listaEstadoModal">
            </condicionGeneralModal>
        </v-card-title>
        <v-container>
            <v-row>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Tipo Condición *" color="textbox" v-model="tipoCondicionFiltro"
                        :items="lista.tipoCondicion" item-text="tipoCondicion" item-value="idTipoCondicion"
                        @change="tipoCondicionCambia" outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="aseguradoraFiltro"
                        :items="lista.aseguradora" item-text="aseguradora" item-value="idAseguradora" @change="listar"
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Seguro *" color="textbox" v-model="seguroFiltro" :items="lista.seguro"
                        item-text="seguro" item-value="idSeguro" @change="listar" outlined dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4" v-if="tipoCondicionFiltro==lista.idLlevaCobertura">
                    <v-autocomplete label="Cobertura *" color="textbox" v-model="coberturaFiltro"
                        :items="lista.cobertura" item-text="cobertura" item-value="idCobertura" @change="listar"
                        outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="estadoFiltro" :items="lista.estado"
                        item-text="nombre_estado" item-value="id_estado" @change="listar" outlined dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" />
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" prepend-inner-icon="search" v-model="buscar" dense />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-data-table :headers="lista.cabecera" :items="lista.detalle" :search="buscar" class="elevation-3">

                        <template v-slot:item.cobertura="{ item }" v-if="_.toNumber(tipoCondicionFiltro)==_.toNumber(lista.idLlevaCobertura)">
                            {{ item.cobertura }}
                        </template>

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>
                        
                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="buscar"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: "CondicionGeneralView",
        components: {
            condicionGeneralModal: () => import('@/components/aseguradora/ModalCondicionGeneralComponent.vue')
        },
        provide: function () {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrarFormulario: this.cerrarFormulario
            }
        },
        data: () => ({
            ProgressBar: true,
            buscar: '',
            dialogForm: false,
            seleccionado: {},
            cabecera: [],
            detalle: [],
            //Listas
            lista: [],
            //Filtros
            estadoFiltro: '0',
            tipoCondicionFiltro: null,
            aseguradoraFiltro: null,
            seguroFiltro: null,
            coberturaFiltro: null,
        }),
        beforeMount() {
            this.cargaGeneral();
        },
        computed: {
            tituloFormulario() {
                return this.seleccionado.idTipoCondicion > "0" ? 'Editar Condición General' : 'Nueva Condición General'
            },
            listaEstadoModal() {
                var listadoEstadoModal = this.lista.estado;
                if (this.lista.estado) {
                    listadoEstadoModal = this.lista.estado.filter(estado => {
                        return estado.visualiza.toLowerCase().includes('true');
                    });
                    this.seleccionado.idEstado = (this.seleccionado.idTipoCondicion > "0") ? this.seleccionado
                        .idEstado : '1';
                }
                return listadoEstadoModal;
            }
        },
        methods: {
            cargaGeneral() {
                axios.post(`${BASE_URI}administrador/condicionGeneral/cargaGeneral`, { opcion: 'L' })
                     .then((r) => {
                        if (r.status != '200') throw mensajeEstandar.errorPeticion;
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                            this.$set(this,'lista',r.data.data);
                            this.tipoCondicionFiltro = r.data.data.idLlevaCobertura;
                    })
                    .catch((er) => {
                        mensajesAlerta(er, "E");
                    });
            },
            editarItem(item) {
                this.seleccionado = Object.assign({}, item),
                    this.dialogForm = true
            },
            cerrarFormulario() {
                this.dialogForm = false;
                this.seleccionado = null;
                this.seleccionado = {};
            },
            tipoCondicionCambia(e) {
                if (!_.isUndefined(e)) {
                    this.coberturaFiltro = null
                    this.listar('e');
                }
            },
            listar(e) {
                if (!_.isUndefined(e)) {
                    this.lista.detalle = [];

                    var objeto = {
                        opcion: 'L',
                        idTipoCondicion: this.tipoCondicionFiltro,
                        idAseguradora: this.aseguradoraFiltro,
                        idSeguro: this.seguroFiltro,
                        idCobertura: this.coberturaFiltro,
                        idEstado: this.estadoFiltro,
                    };
                    
                    return axios.post(`${BASE_URI}administrador/condicionGeneral/listar`, objeto)
                                .then((r) => {
                                    if (r.status != '200') throw mensajeEstandar.errorPeticion;
                                    if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                                        this.lista.detalle = r.data.data.detalle;
                                        this.lista.cabecera = r.data.data.cabecera;
                                    
                                    return r;
                                })
                                .catch(function (er) {
                                    mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                                    return er;
                                });
                }
            },
            insertarActualizar(_opcion) {
                return axios.post(`${BASE_URI}administrador/condicionGeneral/mantenimiento`, {  opcion: _opcion, condicionGeneral: this.seleccionado })
                            .then((r) => {
                                if (r.status != '200') throw mensajeEstandar.errorPeticion;
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    mensajeAlertaTiempo(r.data.mensaje,"S");
                                    return this.listar('e');
                            })
                            .catch(function (er) {
                                mensajesAlerta(mensajeEstandar.errorInesperado, "E");
                                return er;
                            });
            }
        }
    }
</script>